
export default class Toggle {
	constructor(el) {

		this.toggle 		= el
		this.clickToggle 	= this.clickToggle.bind(this)
		this.toggleButtons 	= [...this.toggle.querySelectorAll(".toggle__btn") ];
		this.allTabs 		= document.querySelectorAll("[data-tab]")

	}
  
	init() {
		for (var i = 0; i < this.toggleButtons.length; i++) {
			this.toggleButtons[i].addEventListener('click', this.clickToggle )
		}
	}
  
	clickToggle(event) {

		const inx = this.toggleButtons.indexOf(event.currentTarget)
		const button = this.toggleButtons[inx]
		const tab = document.querySelector(`[data-tab="${button.dataset.opentab}"]`)

		if(button.classList.contains('toggle__btn--active')){
			return
		}

		// OPEN CLICKED
		button.classList.toggle('toggle__btn--active');
		this.toggle.style.setProperty('--distance', inx );

		if( button.ariaExpanded === 'false' ){
			button.setAttribute('aria-selected', 'true');
		} else {
			button.setAttribute('aria-selected', 'false');
		}

		if(tab){
			this.openTab(tab)
			console.log(tab.hidden)
			console.log(this.allTabs)
			this.closeSiblingTabs(tab,this.allTabs)
		}

		this.closeSiblingToggles(button,this.toggleButtons)

	}

	openTab(tab) {

		if( tab.hidden === false ){
			tab.setAttribute('hidden', true)
		} else {
			tab.removeAttribute('hidden')
		}
	}

	closeSiblingTabs(exceptThis,siblings) {
		for (var i = 0; i < siblings.length; i++) {
			if (siblings[i] !== exceptThis) {
				if( siblings[i].hidden === false ){
					siblings[i].setAttribute('hidden', true);
				} else {
					siblings[i].removeAttribute('hidden');
				}
			}
		}
	}

	closeSiblingToggles(exceptThis,siblings) {
		for (var i = 0; i < siblings.length; i++) {
			if (siblings[i] !== exceptThis) {
				siblings[i].classList.remove('toggle__btn--active');
			}
		}
	}
  
}
